import { StateSchema } from 'app/config/storeConfig/types';
import { FeatureFlags } from '../types';

export const getFeatureFlags = (state: StateSchema): Nullable<FeatureFlags> => state.app.featureFlags;
